import React, {useState} from "react";
import {FormikHelpers, useFormik} from "formik";
import {PersonApiPut} from "./people_api";
import * as yup from "yup";
import {
    Box,
    Button,
    CardActions,
    CardContent,
    FormControl,
    FormControlLabel,
    InputAdornment,
    Switch,
    TextField
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import  VisibilityOff from "@mui/icons-material/VisibilityOff";
import {TablesInsert} from "../../apitypes";


interface PersonFormProps {
    onSubmit: (values: TablesInsert<"worker">, formikHelpers: FormikHelpers<any>) => void
    onCancel: () => void
    object: TablesInsert<"worker">,
    isUpdating: boolean,
}

const PersonSchema = yup.object().shape({

    partnerCode: yup.string().min(2).max(40).required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    code: yup.string().required(),
    Active: yup.boolean().required(),
    documentID: yup.string().required(),
})

export default ({object, onSubmit, onCancel, isUpdating}: PersonFormProps) => {
    const formik = useFormik<TablesInsert<"worker">>({
        initialValues: object,
        onSubmit: onSubmit,
        validationSchema: PersonSchema
    });
    const [showText, setShowText] = useState(false)

    return <Box component={"form"} className={"form-100"} onSubmit={formik.handleSubmit}>
        <CardContent>
            <TextField
                name={"documentID"}
                id={"documentID"}
                value={formik.values.documentID}
                label={"Eksterni ID"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.documentID && Boolean(formik.errors.documentID)}
                helperText={formik.touched.documentID && formik.errors.documentID}
            />
            <TextField
                name={"partnerCode"}
                id={"partnerCode"}
                value={formik.values.partnerCode}
                label={"Šifra"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.partnerCode && Boolean(formik.errors.partnerCode)}
                helperText={formik.touched.partnerCode && formik.errors.partnerCode}
            />
            <TextField
                name={"firstName"}
                id={"firstName"}
                value={formik.values.firstName}
                label={"Ime"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
            />

            <TextField
                name={"lastName"}
                id={"lastName"}
                value={formik.values.lastName}
                label={"Priimek"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
            />
            <TextField
                name={"code"}
                id={"code"}
                slotProps={{
                    input: {
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowText(!showText)}
                                onMouseDown={() => setShowText(true)}
                                edge="end"
                            >
                                {showText ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>

                    }
                }}
                type={showText ? "text" : "password"}
                value={formik.values.code}
                label={"Koda za identifikacijo"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.code && Boolean(formik.errors.code)}
                helperText={formik.touched.code && formik.errors.code}
            />

            <FormControl>
                <FormControlLabel label={"Aktiven"} control={<Switch
                    id={"Active"}
                    name={"Active"}
                    onChange={formik.handleChange}
                    checked={formik.values.Active}
                    onBlur={formik.handleBlur}

                />}/>
            </FormControl>
        </CardContent>
        <CardActions>
            <Button disabled={isUpdating} type={"submit"}>Shrani</Button>
            <Button onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Box>

}
